module.exports = __webpack_public_path__ + "static/media/TIM_Logo_2016.971e53a7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/TIM_Logo_2016.png
// module id = 260
// module chunks = 0